<template>
	<svg
		width="5"
		height="8"
		viewBox="0 0 5 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		@click="prev"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3.32809 7.53568L0.146106 4.3537C-0.0491555 4.15844 -0.0491556 3.84186 0.146106 3.6466L3.32809 0.464614C3.52335 0.269352 3.83993 0.269352 4.03519 0.464614C4.23046 0.659877 4.23046 0.976459 4.03519 1.17172L1.20677 4.00015L4.03519 6.82858C4.23046 7.02384 4.23046 7.34042 4.03519 7.53568C3.83993 7.73094 3.52335 7.73094 3.32809 7.53568Z"
			fill="#666666"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PaginateLeft',
	props: {
		currentPage: {
			type: Number,
			required: true,
		},
	},
	methods: {
		prev() {
			if (this.currentPage === 1) {
				return;
			}
			this.$emit('prevPage');
		},
	},
};
</script>
